import React, { useContext ,useEffect,useState} from 'react';
import { GlobalContext } from "../context/GlobalState";
import { Link ,useHistory} from "react-router-dom";
import {
  ListGroup,
  ListGroupItem,
  Button
} from "reactstrap";
import axios from 'axios';
export const UserList = () => {
 
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([])
const history=useHistory()
  useEffect(() => {
    const fetchData = async () =>{
      setLoading(true);
      try {
        const {data: response} = await axios.get('https://princetrack-f6ffc-default-rtdb.europe-west1.firebasedatabase.app/pkg2.json');
        setData(response);
      } catch (error) {
        console.error(error.message);
      }
      setLoading(false);
    }

    fetchData();
    console.log(data)
  }, []);
  return (
    <ListGroup className="mt-4" style={{ maxWidth: "80vw",margin:"auto"}}> 
      {data? (
        <>
          {Object.keys(data).reverse().map((key,ind) => (<div>
            <ListGroupItem className="d-flex" key={key}><div>
             <h4>Tracking number:  <span>{data[key].trackingNumber}</span></h4>
             <h4>Description:  <span>{data[key].description}</span></h4></div>
              <div className="ml-auto">
                  <Link to={`/edit/${key}`} color="warning" className="btn btn-warning mr-1">Edit</Link>
                  <Button color="primary"> <Link style={{color:"white"}}

   to={{
    pathname: `/view/${key}`,
    state: {
      mydata: data[key],
    },
  }}>
View Receipt
</Link>  </Button>
                <Button  color="danger" onClick={()=>{
axios.delete(`https://princetrack-f6ffc-default-rtdb.europe-west1.firebasedatabase.app/pkg2/${key}.json`)
.then(() => {
alert("deleted succesfully reload page")
history.push("/admindash104");




});


                }}>Delete</Button>
              </div>
            </ListGroupItem>
           
            </div>
          ))}
        </>
      ) : (
          <h4 className="text-center">No data</h4>
        )}
    </ListGroup>
  )
}
